var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBoxRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#F12D2D",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 7.83331H18.6667",
    stroke: "#F12D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 11.1667V16.1667",
    stroke: "#F12D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 11.1667V16.1667",
    stroke: "#F12D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 7.83331L6.99996 17.8333C6.99996 18.2753 7.17555 18.6993 7.48811 19.0118C7.80068 19.3244 8.2246 19.5 8.66663 19.5H15.3333C15.7753 19.5 16.1992 19.3244 16.5118 19.0118C16.8244 18.6993 17 18.2753 17 17.8333L17.8333 7.83331",
    stroke: "#F12D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.83333V5.33333C9.5 5.11232 9.5878 4.90036 9.74408 4.74408C9.90036 4.5878 10.1123 4.5 10.3333 4.5H13.6667C13.8877 4.5 14.0996 4.5878 14.2559 4.74408C14.4122 4.90036 14.5 5.11232 14.5 5.33333V7.83333",
    stroke: "#F12D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBoxRed);
export default __webpack_public_path__ + "static/media/trash-box-red.24364e5b411e1d6c073436f3b9b12a84.svg";
export { ForwardRef as ReactComponent };